var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerArtikkelIntervjuLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.3,103.19h-73a1,1,0,0,1-1-1V11.78a1,1,0,0,1,1-1H95a1,1,0,0,1,1,1V95.59a1,1,0,0,1-2,0V12.78H18.32v88.41h72a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.68,43H31.84a1,1,0,0,1-1-1V29.73a1,1,0,0,1,1-1H79.68a1,1,0,0,1,1,1V42A1,1,0,0,1,79.68,43ZM32.84,41H78.68V30.73H32.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.77,54.59H32.35a1,1,0,1,1,0-2H78.77a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.77,62.68H32.35a1,1,0,0,1,0-2H78.77a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.65,70.27H32a1,1,0,0,1,0-2h19.7a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.65,78.36H32a1,1,0,0,1,0-2h19.7a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.65,86.35H32a1,1,0,0,1,0-2h19.7a1,1,0,1,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.91,70.27H59.21a1,1,0,1,1,0-2h19.7a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.91,78.36H59.21a1,1,0,1,1,0-2h19.7a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.91,86.35H59.21a1,1,0,0,1,0-2h19.7a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.72,110.45H26.82V103.7a1,1,0,0,1,2,0v4.75h69.9a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.69,103.49a1,1,0,0,1-1-1v-82H96.35a1,1,0,0,1,0-2h6.34v84A1,1,0,0,1,101.69,103.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerArtikkelIntervjuLarge);
export default __webpack_public_path__ + "static/media/Ikoner_Artikkel-intervju_large.b6ad95496607dde6648465d20d66801f.svg";
export { ForwardRef as ReactComponent };